/**
 * Layout para paginas publicas (no panel, no auth, no flow screens).
 * Monta el Navbar de LandingV2 + un <main> con offset opcional.
 *
 * Uso:
 *   <PublicLayout>...</PublicLayout>            // pt-16 (default)
 *   <PublicLayout withOffset={false}>...</>     // sin pt (hero debajo del navbar)
 */
import { useAuth } from "../auth/AuthContext"
import Navbar from "../pages/LandingV2/_sections/Navbar"

export default function PublicLayout({ children, withOffset = true }) {
  const { user } = useAuth()
  return (
    <div className="min-h-screen bg-white">
      <Navbar user={user} />
      <main className={withOffset ? "pt-16" : ""}>
        {children}
      </main>
    </div>
  )
}
